import { HttpContextToken } from '@angular/common/http';

export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);
export const AUTH_RETRIED = new HttpContextToken<boolean>(() => false);

// A 404 is sometimes a normal, silent outcome rather than something wrong - e.g. "this
// tenant has never run a Clusterize job yet" - not something worth an app-wide error
// toast the way a genuinely broken request is. Set on a request to suppress
// AuthInterceptor's global handleError() for it; the caller still gets the error
// through its own subscription (e.g. via catchError) exactly as before, this only
// silences the toast.
export const SILENCE_ERROR_TOAST = new HttpContextToken<boolean>(() => false);
